"use strict";
const nav = document.querySelector('.nav');
const navTrigger = document.querySelectorAll('.nav__trigger');
navTrigger.forEach(trigger => {
    trigger === null || trigger === void 0 ? void 0 : trigger.addEventListener('click', () => {
        nav === null || nav === void 0 ? void 0 : nav.classList.toggle('nav--open');
        document.body.classList.toggle('body--clipping');
    });
});
